import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SpecialWizardStep } from '../../domain/special-wizard-step';

@Component({
  selector: 'fts-special-wizard-item-selector',
  templateUrl: './special-wizard-item-selector.component.html',
  styleUrls: ['./special-wizard-item-selector.component.scss'],
})
export class SpecialWizardItemSelectorComponent {
  @Input()
  currentStep: SpecialWizardStep;
  @Output()
  itemSelected: EventEmitter<boolean> = new EventEmitter<boolean>();

  onItemSelected(isCustomizing: boolean) {
    this.itemSelected.emit(isCustomizing);
  }
}
